// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3BcFj","cancel":"styles_cancel__FEScx"};